<template>
    <div class="popup popup-cart popup__sizes" :class="{ 'popup-show': show }">
        <div class="popup__wrapper">
            <div class="popup__content">
                <div class="cart">
                    <div class="cart__top-wrapper">
                        <div class="cart__top top-cart">
                            <div class="top-cart__title"></div>
                            <button type="button" class="popup__close _icon-close" @click="closePopup"></button>
                        </div>
                        <div class="flex flex-col gap-3">
                            <NuxtImg v-if="hasKarabinClasp" class="mt-2 w-full object-contain" :src="karabinImg" alt="Карабін застібка" />
                            <NuxtImg v-if="hasTohlClasp" class="mt-2 w-full object-contain" :src="tohlImg" alt="Карабін тогл" />
                            <NuxtImg class="w-full object-contain" :src="kolyeSizes" alt="kolye_sizes.PNG" v-if="category == '34'" />
                            <NuxtImg class="w-full object-contain" :src="brasletSizes" alt="braslet_sizes.webp?v1" v-if="category == '19'" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from "vue";

// Константы для путей к изображениям
const kolyeSizes = new URL("@/assets/img/sizes/kolye_sizes.png", import.meta.url).href;
const brasletSizes = new URL("@/assets/img/sizes/braslet_sizes.webp", import.meta.url).href;
const karabinImg = "/img/product/im3.webp";
const tohlImg = "/img/product/im4.webp";

const { show, category, characteristics } = defineProps({
    show: {
        type: Boolean,
        required: true,
    },
    category: {
        type: [String, Number],
        required: true,
    },
    characteristics: {
        type: Object,
        default: () => ({}),
    },
});

const emit = defineEmits(["update:show"]);

// Картинка для застібки Карабін
const hasKarabinClasp = computed(() => {
    if (!Array.isArray(characteristics)) return false;
    const clasp = characteristics.find((item) => item.filter_name?.toLowerCase() === "тип застібки".toLowerCase());
    if (!clasp) return false;
    return clasp.values?.some((val) => typeof val === "string" && val.toLowerCase().includes("карабін"));
});

const hasTohlClasp = computed(() => {
    if (!Array.isArray(characteristics)) return false;
    const clasp = characteristics.find((item) => item.filter_name?.toLowerCase() === "тип застібки".toLowerCase());
    if (!clasp) return false;
    return clasp.values?.some((val) => typeof val === "string" && val.toLowerCase().includes("тогл"));
});

const closePopup = () => {
    emit("update:show", false);
};

console.log(characteristics);
</script>

<style scope>
.popup__sizes .cart {
    padding: 0 !important;
}
.popup__sizes .popup__wrapper {
    height: auto;
}
</style>
